import gql from "graphql-tag";

export const ADD_FUNDS_TO_TANGO = gql`
  mutation ($input: addFundsInput) {
    addFundsToTangoAccount(input: $input)
  }
`;
